export class StateResultDto {
    code: string;
    state: string;
}
